import React from 'react'
import { Parallax, Background } from 'react-parallax';
import { Link } from 'gatsby';
import { useStaticQuery, graphql } from "gatsby"
import Img from "gatsby-image"

const TechPromo = props => {
  const data = useStaticQuery(graphql`
    query {
      imageOne: file(relativePath: { eq: "smartfield.jpg" }) {
        childImageSharp {
          fixed(width: 1600, height: 1066) {
            ...GatsbyImageSharpFixed
          }
        }
      }
    }
  `)

  return (
    <Parallax
      blur={15}
      strength={300}
    >
      <div className="g-flex-centered g-pos-rel" style={{minHeight: "600px"}} data-sal="slide-up" data-sal-delay="200">
        <div className="container text-center g-color-white g-py-20 g-mb-40">
          <h2 className="h5 g-mb-40 u-in-viewport">
            Ready to take your Hemp business to the Next Level?
          </h2>
          <h3 className="d-inline-block g-brd-y g-brd-2 g-brd-white g-font-weight-700 g-font-size-40 g-font-size-60--md g-line-height-1 g-py-10 g-mb-30 fadeInUp u-in-viewport">
            Hempgrid Technology
          </h3>
          <p className="g-font-size-22 g-mb-40 u-in-viewport">
            is partnering with leading farms, processors, manufacturers and investors to bring the latest technology to the hemp industry
          </p>
          <div data-animation="fadeInUp" className="u-in-viewport">
            <a href="https://www.surveymonkey.com/r/NWG2RNY" className="btn btn-lg u-btn-outline-white g-font-weight-600 g-font-size-13 text-uppercase g-rounded-50 mx-2 g-px-25 g-py-15">
              Take the Survey
            </a>
            <Link to="./signup" className="btn btn-lg u-btn-primary g-font-weight-600 g-font-size-13 text-uppercase g-rounded-50 mx-2 g-px-25 g-py-15">
              Join the Waitlist
            </Link>
          </div>
        </div>
      </div>
      <Background className="custom-bg">
        <Img fixed={data.imageOne.childImageSharp.fixed} />
      </Background>
    </Parallax>
  )
}

export default TechPromo